import { gql } from '@apollo/client'

export default gql(`
mutation deleteMetaFieldConfig($id : ID! $project: String) {
    deleteMetaFieldConfig(
            id: $id
            project: $project
    ) {
        id
    }
}`
)
